import { EnumRichiestaDTOStato } from '@framework/api-client/api/inquiries-compile/schemas/enumRichiestaDTOStato.ts';
import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import dayjs from 'dayjs';

/**
 * Calcola se devo mostrare l'alert di richiesta inviata con successo.
 * Aggiungo una condizione in più per mostrare l'alert per almeno 25 secondi
 * per evitare che scompaia immediatamente.
 */
export function computeShowAlert(submission: RichiestaDTO | undefined) {
  return (
    // Se è solo "inviata" (e non "ricevuta")
    submission?.stato === EnumRichiestaDTOStato.INVIATA ||
    // Se è stata inviata da meno di 25 secondi
    dayjs().subtract(25, 'seconds').isBefore(dayjs(submission?.dataInvio))
  );
}
